/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from './@core/utils/analytics.service';
import * as socketIo from "socket.io-client";
import { SettingsService } from './settings/settings.service';
import { TokenService } from './@core/services/token.service';
// LIST KNOWN ISSUES
// [Violation] Added non-passive event listener; https://github.com/angular/angular/issues/8866
@Component({
  selector: 'ngx-app',
  template: '<ngx-main></ngx-main>',
})
export class AppComponent implements OnInit {
  authData;
  currentUserId;
  constructor(private analytics: AnalyticsService, 
    private settingsServiceHere: SettingsService,
    private tokenService: TokenService ) {
    // this.authData = this.tokenService.getToken();
    //   console.log("authData",this.authData.user._id);
    // this.currentUserId = this.authData.user._id
  }
accessMessage;
  ngOnInit(): void {
    this.analytics.trackPageViews();
		// const socket = socketIo("http://70.32.30.56:9010");
		// socket.on("hello"+this.currentUserId, (data)=>{
    //   console.log("data", data);
    //   this.accessMessage = data;
    //    alert(this.accessMessage.type);
    // });
 
 

  }

  alertFtn(){
    alert("lasdlahsdlas");
    this.settingsServiceHere.loadTrackingMapPins.next("hitted");
    alert("lasdlahsdlas");

  }

}
